"use strict";

angular.module("core")
.component("invoiceAttachment", {
    templateUrl: require("./invoice-attachment.component.html"),
    controllerAs: "invoiceAttachmentCtrl",
    bindings: {
        invoice: "<",
        dedicatedVendorId: "<?"
    },
    controller: invoiceAttachmentController
});

function invoiceAttachmentController($scope) {
    $scope.invoice = this.invoice;
    $scope.dedicatedVendorId = this.dedicatedVendorId;
}



//////////////////
// WEBPACK FOOTER
// ./core/invoice-attachment/invoice-attachment.component.js
// module id = 629
// module chunks = 0